import React, { Component } from "react";
import { Link } from "react-router-dom";

import { Formik, Form } from "formik";
import { ChangePasswordSchema } from "../forms/schema";
import { IconTextInput } from "../forms/components";

import { doLogout, changePassword, getAccessControl } from "../libs/functions";

import Joyride, { STATUS } from "react-joyride";

import Sentry from "react-activity/lib/Sentry";
import "react-activity/lib/Sentry/Sentry.css";

import logo from "../assets/img/logo.png";
import Swal from "sweetalert2";

class Container extends Component {
	state = {
		mainNav: [
			// {
			//   name: "Transactions",
			//   icon: "fa-regular-list-alt",
			//   href: "/transactions",
			// },
			{ name: "Merchants", icon: "fa-solid-store-alt", href: "/merchants" },
			{
				name: "Commissions",
				icon: "fa-solid-money-check-alt",
				href: "/commissions",
			},
			//   { name: "KYC", icon: "fa-solid-file-alt", href: "" },
		],
		userData: {},
		isLoading: this.props.loading || false,
		run: false,
	};

	componentDidMount = async () => {
		this.setState({
			userData: window._USER_DATA_,
			master: (await getAccessControl()) === "master",
		});
	};

	componentDidUpdate = (prevProps) => {
		// console.log(prevProps.loading, this.props.loading);
		if (prevProps.loading !== this.props.loading) {
			this.loader(this.props.loading);
		}
	};

	closeModal = (ele) => {
		return UIkit.modal(ele).hide();
	};

	handleChangePassword = (values, { setSubmitting, resetForm }) => {
		Swal.fire({
			title: "Changing Password",
			allowOutsideClick: false,
			allowEscapeKey: false,
			onBeforeOpen: () => {
				this.closeModal("#change-password").then(() => {
					resetForm();
				});
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					let status = await changePassword(
						values.opassword,
						values.npassword,
						values.cpassword
					);
					setSubmitting(false);
					resetForm();

					if (status) {
						Swal.fire({
							title: "Password Changed",
						}).then(() => {
							this.logout();
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unable to change password",
						});
					}
				} catch (err) {
					console.log(err);
					setSubmitting(false);
					Swal.fire({
						icon: "error",
						title: "Unable to change password",
					}).then(() => {
						resetForm();
					});
				}
			},
		});
	};

	loader = (state) => {
		this.setState({ isLoading: state });
	};

	logout = () => {
		doLogout().then(() => {
			window.location = "/login";
		});
	};

	runTutorial = () => {
		if (this.props.tutorial) this.setState({ run: true });
	};

	handleTutorialCallback = ({ action, index, status, type }) => {
		if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
			// Need to set our running state to false, so we can restart if we click start again.
			this.setState({ run: false });
		}
	};

	render() {
		const {
			mainNav,
			isLoading,
			userData: { username, partner },
			run,
			master,
		} = this.state;
		const { activeMenu, tutorial } = this.props;
		return (
			<>
				{tutorial && (
					<Joyride
						styles={{ options: { primaryColor: "#E5742E" } }}
						steps={tutorial}
						continuous={true}
						run={run}
						callback={this.handleTutorialCallback}
					/>
				)}
				<div className="container">
					<div className="main-navbar">
						<nav
							className="uk-navbar-container uk-navbar-transparent"
							uk-navbar=""
						>
							<div className="uk-navbar-left">
								<a
									className="uk-navbar-item uk-logo uk-margin-medium-left"
									href="/dashboard"
								>
									<div className="logo uk-flex uk-flex-middle">
										<img className="uk-img" src={logo} width="40" />
										<span className="uk-margin-small-left uk-text-bold">
											T05 PAY
										</span>
									</div>
									<span className="uk-label partner-tag">PARTNER</span>
								</a>
							</div>
							<div className="uk-navbar-right uk-margin-medium-right ">
								<ul className="uk-navbar-nav uk-flex uk-flex-middle">
									<li className="account-settings">
										<a href="#">
											<i uk-icon="icon: fa-regular-user-circle; ratio: 1.3" />
											<span className="uk-text-bold uk-margin-small-left uk-margin-small-right uk-flex uk-flex-column">
												<span>{partner}</span>
												<small>{username}</small>
											</span>
											<i uk-icon="icon: fa-solid-caret-down" />
										</a>
										<div className="uk-navbar-dropdown">
											<ul className="uk-nav uk-navbar-dropdown-nav">
												<li>
													<a href="#change-password" uk-toggle="">
														<span className="uk-flex uk-flex-middle">
															<i uk-icon="icon: fa-solid-key; ratio: 0.8" />
															<span className="uk-margin-small-left">
																Change Password
															</span>
														</span>
													</a>
												</li>
												<li className="uk-margin-small-top">
													<a onClick={this.logout}>
														<span className="uk-flex uk-flex-middle">
															<i uk-icon="icon: fa-solid-sign-out-alt; ratio: 0.8" />
															<span className="uk-margin-small-left">
																Logout
															</span>
														</span>
													</a>
												</li>
											</ul>
										</div>
									</li>
								</ul>
							</div>
						</nav>
					</div>
					<div className="uk-grid" uk-height-viewport="offset-top: true">
						<div className="side-navbar uk-width-auto">
							<ul className="uk-nav-primary uk-nav">
								{mainNav.map((nav, index) => {
									return (
										<li
											key={index}
											className={activeMenu === nav.name ? "uk-active" : ""}
											disabled={nav.disabled || false}
										>
											{nav.disabled !== true ? (
												<Link className={`link ${nav.class}`} to={nav.href}>
													<i uk-icon={`icon: ${nav.icon}`} />
													<p>{nav.name}</p>
												</Link>
											) : (
												<a
													className={`link uk-flex uk-flex-middle ${nav.class}`}
												>
													<i uk-icon={`icon: ${nav.icon}`} />
													<div>
														<p>{nav.name}</p>
														<span className="uk-label coming-soon-tag">
															Coming Soon
														</span>
													</div>
												</a>
											)}
										</li>
									);
								})}
								{master && (
									<>
										<li className={activeMenu === "Reports" ? "uk-active" : ""}>
											<Link className="link" to="/reports">
												<i uk-icon={`icon: fa-solid-file-invoice-dollar`} />
												<p>Reports</p>
											</Link>
										</li>
										<li
											className={activeMenu === "Resellers" ? "uk-active" : ""}
										>
											<Link className="link" to="/resellers">
												<i uk-icon={`icon: fa-solid-list`} />
												<p>Resellers</p>
											</Link>
										</li>
									</>
								)}
							</ul>
							{/* <ul className="uk-nav-primary uk-nav uk-position-bottom uk-margin-bottom">
							<li>
								<a className="link" onClick={this.runTutorial}>
									<i uk-icon="icon: fa-regular-question-circle" />
									<p>Guide</p>
								</a>
							</li>
						</ul> */}
						</div>
						<div className="content uk-width-expand uk-padding">
							{this.props.children}
						</div>
					</div>
					<div id="change-password" uk-modal="">
						<div className="uk-modal-dialog uk-modal-body">
							<h2 className="uk-modal-title">Change Password</h2>
							<Formik
								initialValues={ChangePasswordSchema.initialValues}
								validationSchema={ChangePasswordSchema.validation}
								onSubmit={this.handleChangePassword}
							>
								<Form className="uk-form-stacked">
									<IconTextInput
										icon="lock"
										id="opassword"
										name="opassword"
										type="password"
										placeholder="Old Password"
									/>
									<IconTextInput
										icon="lock"
										id="npassword"
										name="npassword"
										type="password"
										placeholder="New Password"
									/>
									<IconTextInput
										icon="lock"
										id="cpassword"
										name="cpassword"
										type="password"
										placeholder="Confirm Password"
									/>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default uk-modal-close"
											type="button"
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Change Password
										</button>
									</p>
								</Form>
							</Formik>
						</div>
					</div>
					<Sentry
						className="uk-position-center"
						size={50}
						color="#E5732E"
						animating={isLoading}
					/>
				</div>
			</>
		);
	}
}

export default Container;
